'use client';

import { usePathname } from '@/navigation';
import { useEffect } from 'react';
import { useModals } from './ModalContext';
import { AfterCoinBought } from '@/modals/AfterCoinBoughtModal';

export const MonetizationContextProvider = ({ children }) => {
  const pathname = usePathname();
  const { open } = useModals();

  useEffect(() => {
    const read = () => {
      const url = new URL(window.location.href);
      const afterPaymentId = url.searchParams.get('after-payment-id');
      if (afterPaymentId) {
        open(
          'after-coin-bought-modal',
          <AfterCoinBought
            afterPaymentId={afterPaymentId}
            removeFromUrl={() => {
              window.history.replaceState({}, '', window.location.pathname);
            }}
          />,
          true,
          'md:h-unset h-unset absolute md:static ',
        );
      }
    };

    // initial
    read();

    // react to back/forward
    const onPopState = () => read();
    window.addEventListener('popstate', onPopState);

    return () => {
      window.removeEventListener('popstate', onPopState);
    };
    // re-run on pathname change (client navs)
  }, [pathname, open]);

  return children;
};
